import * as React from "react";
import { inject, observer } from "mobx-react";
import { AdvertisingStore } from "src/stores/AdvertisingStore";
import { UitkPlaceholderCard } from "uitk-react-cards";

enum view {
  ad,
  loader,
  fallback
}

const mesoAdEventName = "mesoAd";

interface NativeAdProps {
  uci: string;
  type: string;
  children?: JSX.Element[] | JSX.Element;
  advertising?: AdvertisingStore;
  className?: string;
}

export const NativeAd: React.SFC<NativeAdProps> = inject("advertising")(
  observer((props: NativeAdProps) => {
    const { uci, type, children } = props;
    const mesoNative: React.RefObject<JSX.IntrinsicElements["meso-native"]> = React.createRef();
    const [initialView, setCurrentView] = React.useState(view.loader);
    let currentView = initialView;

    if (props.advertising && props.advertising.adBlockerEnabled === true) {
      currentView = view.fallback;
    }

    const removeAdLoadEventHandler = () => {
      if (mesoNative && mesoNative.current) {
        mesoNative.current.removeEventListener(mesoAdEventName, handleAdLoadEvent);
      }
    };

    const handleAdLoadEvent = (event: CustomEvent) => {
      setCurrentView(
        event.detail && event.detail.code === "AD-LOAD-PASS" ? view.ad : view.fallback
      );
      removeAdLoadEventHandler();
    };

    React.useEffect(
      () => {
        if (props.advertising) {
          props.advertising.includeAd();
        }
        if (mesoNative && mesoNative.current) {
          mesoNative.current.addEventListener(mesoAdEventName, handleAdLoadEvent);
        }

        return removeAdLoadEventHandler;
      },
      [mesoNative.current]
    );

    return (
      <React.Fragment>
        <meso-native
          class={currentView === view.ad ? " " : "is-visually-hidden"}
          uci={uci}
          nativetype={type}
          isfluid={true}
          adslot={uci}
          data-testid="meso-native"
          ref={mesoNative}
        />
        {currentView === view.loader && <UitkPlaceholderCard className="horizontal-placeholder" />}
        {currentView === view.fallback ? children : null}
      </React.Fragment>
    );
  })
);
